import React, { FC } from 'react';
import NextLink from 'next/link';
import { Link, Icon } from '@whitesharx/starfall-frontend-ui-kit';
import { UserInfoSkeleton as UserInfoFrameSkeleton } from '@whitesharx/starfall-frontend-core';

import { userIconContainerStyles, contentContainerStyles } from './styles.css';

export type UserInfoProps = {
  withoutProfileLink?: boolean;
};

export const UserInfoSkeleton: FC<UserInfoProps> = ({ withoutProfileLink }) => {
  const ProfileLink = withoutProfileLink ? undefined : (
    <NextLink href="/profile" passHref>
      <Link>
        <div className={contentContainerStyles}>
          <div className={userIconContainerStyles}>
            <Icon color="purple100" name="player" size="16" />
          </div>
        </div>
      </Link>
    </NextLink>
  );

  return <UserInfoFrameSkeleton ProfileLink={ProfileLink} />;
};
